import { AbgabebelegPosition } from './abgabebeleg-position';

export class Abgabebeleg {
    abgabebeleg_id: number;
    abgabebeleg_nr: string;
    kunde_id: number;
    kunde: string;
    tierbewegung_melden: number;
    bezeichnung: string;
    erstellt: Date;
    positionen: AbgabebelegPosition[] = [];
    status_id: number;
    status_id_neu: number;
    status: string;
    datum: Date;
    tierarzt_id: number;
    tierarzt: string;
    pdf_id: number;
    pdf_id_bestandsbuch: number;
    pdf_id_impfkontrollbuch: number;
    selbstimpfer: number;
    rechnung_ids: string;
    dbhinweis: string;
    betrieb_id: number;
    kunde_nr_intern: number;
    betriebsart_kaelbermast: number;
    betriebsart_ohrmarke: number;
    abgabebeleg_id_neuverschreibung: number;
    abgabebeleg_nr_nv: string;
}

export class AbgabebelegCharge {
    charge_id: number;
    menge_beleg: number;
    menge_auto: number;
    charge: string;
    mhd: Date;
    lagerplatz_id: number;
}

export class PositionCharge {
    aa_id: number;
    ac_id: number;
    charge: string;
    charge_id: number;
    chargenmenge: number;
    mhd: Date;
    lagerplatz_id: number;
}

export class AbgabebelegStatus {
    public static ERSTELLT = 41;
    public static ABGESCHLOSSEN = 42;
    public static WIRD_KORRIGIERT = 46;
    public static STORNIERT = 47;
    public static NEUVERSCHREIBUNG = 49;
}

export class AbgabebelegWarenkorb {
    aw_id: number;
    kunde_id: number;
    kunde: string;
    zusatz: string;
    artikel_id: number;
    artikel_me: string;
    artikelmenge: number;
    editiert: Date;
}
